module.exports = __webpack_public_path__ + "static/media/dempsey.e09f447e.jpg";